import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export const PageTracker = () => {
  const location = useLocation();
  useEffect(() => {
    try {
      let vid = localStorage.getItem("jby_vid");
      if (!vid) {
        vid = crypto.randomUUID();
        localStorage.setItem("jby_vid", vid);
      }
      api.post("/track", { path: location.pathname, visitor_id: vid }).catch(() => {});
    } catch {
      // tracking must never break the app
    }
  }, [location.pathname]);
  return null;
};
